export default "__VITE_ASSET__HMDm57jv__"